/**
 * gsap-init.js
 * Centralised GSAP animation init for all sections.
 * Loaded once from theme.liquid — no gsap:ready listeners in individual sections.
 * Handles both storefront (initial load) and Shopify Theme Editor (section:load events).
 */

(function () {

  /* ─── Zoom-in helper (scale + opacity) ─────────────────────────── */
  function zoomIn(el) {
    if (!el) return;
    var rect = el.getBoundingClientRect();
    var vh   = window.innerHeight;
    el.style.willChange = 'transform, opacity';
    if (rect.bottom < 0) return; /* already scrolled past */
    if (rect.top < vh) {
      gsap.fromTo(el, { opacity: 0, scale: 0.88 },
        { opacity: 1, scale: 1, duration: 0.85, ease: 'power2.out', clearProps: 'willChange' });
    } else {
      gsap.fromTo(el, { opacity: 0, scale: 0.88 },
        { opacity: 1, scale: 1, duration: 0.85, ease: 'power2.out', clearProps: 'willChange',
          scrollTrigger: { trigger: el, start: 'top 75%', once: true } });
    }
  }

  /* ─── Per-section init functions ───────────────────────────────── */

  function initMainBanner(s) {
    var badge      = s.querySelector('.main-banner-badge');
    var heading    = s.querySelector('.main-banner-heading');
    var desc       = s.querySelector('.main-banner-description');
    var buttons    = s.querySelector('.main-banner-buttons');
    var badgeItems = s.querySelectorAll('.main-banner-badge-item');
    var image      = s.querySelector('.main-banner-image');
    GSAPAnim.reveal(badge      ? [badge]   : [], { triggerEl: s, start: 'top 100%', fromY: -30, duration: 0.9 });
    GSAPAnim.reveal(heading    ? [heading] : [], { triggerEl: s, start: 'top 100%', fromY: 60,  duration: 1.0,  delay: 0.20 });
    GSAPAnim.reveal(desc       ? [desc]    : [], { triggerEl: s, start: 'top 100%', fromY: 50,  duration: 0.9,  delay: 0.45 });
    GSAPAnim.reveal(buttons    ? [buttons] : [], { triggerEl: s, start: 'top 100%', fromY: 40,  duration: 0.85, delay: 0.65 });
    GSAPAnim.reveal(badgeItems,                   { triggerEl: s, start: 'top 100%', fromY: 30,  duration: 0.8,  stagger: 0.15, delay: 0.85 });
    GSAPAnim.reveal(image      ? [image]   : [], { triggerEl: s, start: 'top 100%', fromX: 100, fromY: 0, duration: 1.1, delay: 0.15 });
  }

  function initIconCards(s) {
    var heading = s.querySelector('.icon-cards-heading');
    var grid    = s.querySelector('.icon-cards-grid');
    var cards   = s.querySelectorAll('.icon-cards-card');
    GSAPAnim.reveal(heading ? [heading] : [], { start: 'top 70%', fromY: 36, duration: 0.8 });
    GSAPAnim.reveal(cards, { triggerEl: grid, start: 'top 68%', fromY: 50, stagger: 0.18, duration: 0.7 });
  }

  function initCollectionListing(s) {
    var heading  = s.querySelector('.collection-listing-title');
    var subtitle = s.querySelector('.collection-listing-subtitle');
    var viewAll  = s.querySelector('.collection-listing-view-all');
    var grid     = s.querySelector('.collection-listing-grid');
    var cards    = s.querySelectorAll('.collection-listing-card');
    GSAPAnim.reveal(heading  ? [heading]  : [], { start: 'top 70%', fromY: 36, duration: 0.8 });
    GSAPAnim.reveal(subtitle ? [subtitle] : [], { triggerEl: heading, start: 'top 70%', fromY: 24, duration: 0.7, delay: 0.12 });
    GSAPAnim.reveal(viewAll  ? [viewAll]  : [], { triggerEl: heading, start: 'top 70%', fromY: 20, duration: 0.7, delay: 0.20 });
    GSAPAnim.reveal(cards, { triggerEl: grid, start: 'top 68%', fromY: 50, stagger: 0.18, duration: 0.7 });
  }

  function initShopBestSellers(s) {
    var heading     = s.querySelector('.sbs-heading');
    var pills       = s.querySelectorAll('.sbs-pill');
    var activePanel = s.querySelector('.sbs-panel.active');
    var cards       = s.querySelectorAll('.sbs-card');
    GSAPAnim.reveal(heading ? [heading] : [], { start: 'top 70%', fromY: 36, duration: 0.8 });
    GSAPAnim.reveal(pills,  { triggerEl: heading,     start: 'top 70%', fromY: 24, stagger: 0.10, delay: 0.15, duration: 0.6 });
    GSAPAnim.reveal(cards,  { triggerEl: activePanel, start: 'top 72%', fromY: 50, stagger: 0.12, duration: 0.7 });
  }

  function initCollectionTabbing(s) {
    var heading     = s.querySelector('.ctab-heading');
    var pills       = s.querySelectorAll('.ctab-pill');
    var activePanel = s.querySelector('.ctab-panel.active');
    var cards       = s.querySelectorAll('.ctab-panel.active .ctab-card');
    GSAPAnim.reveal(heading ? [heading] : [], { start: 'top 70%', fromY: 36, duration: 0.8 });
    GSAPAnim.reveal(pills,  { triggerEl: heading,     start: 'top 70%', fromY: 24, stagger: 0.10, delay: 0.15, duration: 0.6 });
    GSAPAnim.reveal(cards,  { triggerEl: activePanel, start: 'top 72%', fromY: 50, stagger: 0.12, duration: 0.7 });
  }

  function initFeaturesStrip(s) {
    var content = s.querySelector('.features-strip__content') || s;
    var items   = s.querySelectorAll('.features-strip__item');
    if (!items.length) return;
    GSAPAnim.reveal(items, { triggerEl: content, start: 'top 72%', fromY: 50, stagger: 0.15, duration: 0.7 });
  }

  function initTestimonialsSlider(s) {
    var heading     = s.querySelector('.tsl-heading');
    var sliderOuter = s.querySelector('.tsl-slider-outer');
    GSAPAnim.reveal(heading ? [heading] : [], { start: 'top 72%', fromY: 36, duration: 0.8 });
    zoomIn(sliderOuter);
  }

  function initComparison(s) {
    var heading  = s.querySelector('.cmp-heading');
    var imgWraps = s.querySelectorAll('.cmp-img-wrap');
    var rows     = s.querySelectorAll('.cmp-row');
    GSAPAnim.reveal(heading  ? [heading] : [], { start: 'top 70%', fromY: 36, duration: 0.8 });
    GSAPAnim.reveal(imgWraps, { triggerEl: heading,                         start: 'top 68%', fromY: 50, stagger: 0.18, duration: 0.75 });
    GSAPAnim.reveal(rows,     { triggerEl: s.querySelector('.cmp-rows'),    start: 'top 72%', fromY: 30, stagger: 0.10, duration: 0.6 });
  }

  function initPositiveResources(s) {
    var heading  = s.querySelector('.pr-heading');
    var featured = s.querySelector('.pr-featured');
    var cards    = s.querySelectorAll('.pr-card');
    GSAPAnim.reveal(heading ? [heading] : [], { start: 'top 72%', fromY: 36, duration: 0.8 });
    zoomIn(featured);
    GSAPAnim.reveal(cards, { triggerEl: s.querySelector('.pr-cards') || cards[0], start: 'top 75%', fromY: 50, stagger: 0.15, duration: 0.7 });
  }

  function initNewsletterBar(s) {
    var heading  = s.querySelector('.nbar-heading');
    var formWrap = s.querySelector('.nbar-form-wrap');
    GSAPAnim.reveal(heading  ? [heading]  : [], { start: 'top 80%', fromX: -60, fromY: 0, duration: 0.8 });
    GSAPAnim.reveal(formWrap ? [formWrap] : [], { start: 'top 80%', fromX:  60, fromY: 0, duration: 0.8, delay: 0.15 });
  }

  function initFooter(s) {
    var cols = s.querySelectorAll('.ftr-col');
    GSAPAnim.reveal(cols, { triggerEl: s.querySelector('.ftr-cols') || cols[0], start: 'top 88%', fromY: 40, stagger: 0.12, duration: 0.7 });
  }

  function initProductTemplate(s) {
    var gallery    = s.querySelector('#product-gallery');
    var pdpBadges  = s.querySelector('.pdp-badges');
    var title      = s.querySelector('h1.product-item-caption-title');
    var price      = s.querySelector('.product-item-caption-price');
    var desc       = s.querySelector('.product-item-caption-desc.description-first-part');
    var variants   = s.querySelector('.product-item-caption-select');
    var cta        = s.querySelector('.pdp-cta-section');
    var trust      = s.querySelector('.product-trust-badges');
    var accordions = s.querySelectorAll('.pdp-accord');
    GSAPAnim.reveal(gallery   ? [gallery]   : [], { triggerEl: s, start: 'top 100%', fromX: -50, fromY: 0, duration: 0.9, delay: 0.05 });
    GSAPAnim.reveal(pdpBadges ? [pdpBadges] : [], { triggerEl: s, start: 'top 100%', fromY: -14, duration: 0.6 });
    GSAPAnim.reveal(title     ? [title]     : [], { triggerEl: s, start: 'top 100%', fromY: 44,  duration: 0.9, delay: 0.10 });
    GSAPAnim.reveal(price     ? [price]     : [], { triggerEl: s, start: 'top 100%', fromY: 28,  duration: 0.7, delay: 0.22 });
    GSAPAnim.reveal(desc      ? [desc]      : [], { triggerEl: s, start: 'top 100%', fromY: 24,  duration: 0.7, delay: 0.32 });
    GSAPAnim.reveal(variants  ? [variants]  : [], { triggerEl: s, start: 'top 100%', fromY: 20,  duration: 0.7, delay: 0.40 });
    GSAPAnim.reveal(cta       ? [cta]       : [], { triggerEl: s, start: 'top 100%', fromY: 20,  duration: 0.7, delay: 0.50 });
    GSAPAnim.reveal(trust     ? [trust]     : [], { triggerEl: s, start: 'top 100%', fromY: 20,  duration: 0.6, delay: 0.60 });
    GSAPAnim.reveal(accordions,                    { triggerEl: s, start: 'top 100%', fromY: 16,  duration: 0.5, stagger: 0.08, delay: 0.70 });
  }

  function initArticlePage(s) {
    var breadcrumb = s.querySelector('.art__breadcrumb');
    var category   = s.querySelector('.art__category');
    var title      = s.querySelector('.art__title');
    var meta       = s.querySelector('.art__meta');
    var heroImg    = s.querySelector('.art__hero-img-wrap');
    var content    = s.querySelector('.art__content');
    var sidebar    = s.querySelector('.art__sidebar');
    /* Hero section — fires on load */
    GSAPAnim.reveal(breadcrumb ? [breadcrumb] : [], { triggerEl: s, start: 'top 100%', fromY: -14, duration: 0.6 });
    GSAPAnim.reveal(category   ? [category]   : [], { triggerEl: s, start: 'top 100%', fromY: 20,  duration: 0.6, delay: 0.08 });
    GSAPAnim.reveal(title      ? [title]      : [], { triggerEl: s, start: 'top 100%', fromY: 44,  duration: 0.9, delay: 0.16 });
    GSAPAnim.reveal(meta       ? [meta]       : [], { triggerEl: s, start: 'top 100%', fromY: 20,  duration: 0.7, delay: 0.28 });
    zoomIn(heroImg);
    /* Body — fires on scroll */
    GSAPAnim.reveal(content ? [content] : [], { triggerEl: content, start: 'top 82%', fromY: 30, duration: 0.8 });
    GSAPAnim.reveal(sidebar ? [sidebar] : [], { triggerEl: sidebar, start: 'top 82%', fromX: 40, fromY: 0, duration: 0.8, delay: 0.15 });
  }

  function initBlogBanner(s) {
    var eyebrow = s.querySelector('.bb__eyebrow');
    var heading = s.querySelector('.bb__heading');
    var desc    = s.querySelector('.bb__description');
    var navWrap = s.querySelector('.bb__nav-wrap');
    GSAPAnim.reveal(eyebrow  ? [eyebrow]  : [], { triggerEl: s, start: 'top 100%', fromY: -16, duration: 0.6 });
    GSAPAnim.reveal(heading  ? [heading]  : [], { triggerEl: s, start: 'top 100%', fromY: 44,  duration: 0.9, delay: 0.10 });
    GSAPAnim.reveal(desc     ? [desc]     : [], { triggerEl: s, start: 'top 100%', fromY: 24,  duration: 0.7, delay: 0.22 });
    GSAPAnim.reveal(navWrap  ? [navWrap]  : [], { triggerEl: s, start: 'top 100%', fromY: 20,  duration: 0.6, delay: 0.34 });
  }

  function initFeaturedBlog(s) {
    var imgCol  = s.querySelector('.fb__image-col');
    var content = s.querySelector('.fb__content');
    var meta    = s.querySelector('.fb__meta');
    var title   = s.querySelector('.fb__title');
    var excerpt = s.querySelector('.fb__excerpt');
    var btn     = s.querySelector('.fb__btn');
    zoomIn(imgCol);
    GSAPAnim.reveal(meta    ? [meta]    : [], { triggerEl: content, start: 'top 78%', fromY: 20, duration: 0.6 });
    GSAPAnim.reveal(title   ? [title]   : [], { triggerEl: content, start: 'top 78%', fromY: 36, duration: 0.8, delay: 0.10 });
    GSAPAnim.reveal(excerpt ? [excerpt] : [], { triggerEl: content, start: 'top 78%', fromY: 24, duration: 0.7, delay: 0.22 });
    GSAPAnim.reveal(btn     ? [btn]     : [], { triggerEl: content, start: 'top 78%', fromY: 18, duration: 0.6, delay: 0.34 });
  }

  function initBlogListing(s) {
    var heading = s.querySelector('.bl__heading');
    var viewAll = s.querySelector('.bl__view-all');
    var cards   = s.querySelectorAll('.bl__card');
    var sidebar = s.querySelector('.bl__sidebar');
    var header  = s.querySelector('.bl__header');
    GSAPAnim.reveal(heading ? [heading] : [], { triggerEl: header || s, start: 'top 80%', fromY: 30, duration: 0.7 });
    GSAPAnim.reveal(viewAll ? [viewAll] : [], { triggerEl: header || s, start: 'top 80%', fromY: 20, duration: 0.6, delay: 0.10 });
    GSAPAnim.reveal(cards,                     { triggerEl: s,          start: 'top 82%', fromY: 50, duration: 0.7, stagger: 0.10, delay: 0.15 });
    GSAPAnim.reveal(sidebar ? [sidebar] : [], { triggerEl: s,          start: 'top 82%', fromX: 40, fromY: 0, duration: 0.8, delay: 0.20 });
  }

  function initContactBanner(s) {
    var eyebrow  = s.querySelector('.contact-hero__eyebrow');
    var title    = s.querySelector('.contact-hero__title');
    var subtitle = s.querySelector('.contact-hero__subtitle');
    GSAPAnim.reveal(eyebrow  ? [eyebrow]  : [], { triggerEl: s, start: 'top 100%', fromY: -16, duration: 0.6 });
    GSAPAnim.reveal(title    ? [title]    : [], { triggerEl: s, start: 'top 100%', fromY: 44,  duration: 0.9, delay: 0.10 });
    GSAPAnim.reveal(subtitle ? [subtitle] : [], { triggerEl: s, start: 'top 100%', fromY: 24,  duration: 0.7, delay: 0.22 });
  }

  function initContactTemplate(s) {
    var formCol   = s.querySelector('.ct-form-col');
    var heading   = s.querySelector('.ct-form-heading');
    var sub       = s.querySelector('.ct-form-sub');
    var fields    = s.querySelectorAll('.ct-field, .ct-field-row');
    var submitRow = s.querySelector('.ct-submit-row');
    var cards     = s.querySelectorAll('.ct-block-card, .ct-block-image');
    GSAPAnim.reveal(heading   ? [heading]   : [], { triggerEl: formCol || s, start: 'top 78%', fromY: 36, duration: 0.8 });
    GSAPAnim.reveal(sub       ? [sub]       : [], { triggerEl: formCol || s, start: 'top 78%', fromY: 22, duration: 0.7, delay: 0.12 });
    GSAPAnim.reveal(fields,                        { triggerEl: formCol || s, start: 'top 78%', fromY: 20, duration: 0.55, stagger: 0.08, delay: 0.20 });
    GSAPAnim.reveal(submitRow ? [submitRow] : [], { triggerEl: formCol || s, start: 'top 78%', fromY: 18, duration: 0.6, delay: 0.50 });
    GSAPAnim.reveal(cards,                         { triggerEl: s,           start: 'top 80%', fromY: 40, duration: 0.7, stagger: 0.12, delay: 0.10 });
  }

  function initContactFaq(s) {
    var eyebrow = s.querySelector('.cfaq__eyebrow');
    var heading = s.querySelector('.cfaq__heading');
    var subtitle = s.querySelector('.cfaq__subtitle');
    var header  = s.querySelector('.cfaq__header');
    var items   = s.querySelectorAll('.cfaq__item');
    GSAPAnim.reveal(eyebrow  ? [eyebrow]  : [], { triggerEl: header || s, start: 'top 78%', fromY: 20, duration: 0.6 });
    GSAPAnim.reveal(heading  ? [heading]  : [], { triggerEl: header || s, start: 'top 78%', fromY: 36, duration: 0.8, delay: 0.10 });
    GSAPAnim.reveal(subtitle ? [subtitle] : [], { triggerEl: header || s, start: 'top 78%', fromY: 22, duration: 0.7, delay: 0.20 });
    GSAPAnim.reveal(items,                        { triggerEl: s,          start: 'top 80%', fromY: 28, duration: 0.6, stagger: 0.08, delay: 0.10 });
  }

  function initPartners(s) {
    var eyebrow = s.querySelector('.partners__eyebrow');
    var logos   = s.querySelectorAll('.partners__logo-item');
    GSAPAnim.reveal(eyebrow ? [eyebrow] : [], { triggerEl: s, start: 'top 82%', fromY: 20, duration: 0.6 });
    GSAPAnim.reveal(logos,                     { triggerEl: s, start: 'top 82%', fromY: 30, duration: 0.55, stagger: 0.07, delay: 0.15 });
  }

  function initRichText(s) {
    var title   = s.querySelector('.hero-text__title');
    var text    = s.querySelector('.hero-text__subheading');
    var btn     = s.querySelector('.hero-text__btn');
    var caption = s.querySelector('.hero-text__caption') || s;
    GSAPAnim.reveal(title ? [title] : [], { triggerEl: caption, start: 'top 80%', fromY: 36, duration: 0.8 });
    GSAPAnim.reveal(text  ? [text]  : [], { triggerEl: caption, start: 'top 80%', fromY: 24, duration: 0.7, delay: 0.15 });
    GSAPAnim.reveal(btn   ? [btn]   : [], { triggerEl: caption, start: 'top 80%', fromY: 18, duration: 0.6, delay: 0.28 });
  }

  function initOurValues(s) {
    var eyebrow = s.querySelector('.ov__eyebrow');
    var heading = s.querySelector('.ov__heading');
    var sub     = s.querySelector('.ov__subheading');
    var header  = s.querySelector('.ov__header');
    var cards   = s.querySelectorAll('.ov__card');
    GSAPAnim.reveal(eyebrow ? [eyebrow] : [], { triggerEl: header || s, start: 'top 78%', fromY: 20,  duration: 0.6 });
    GSAPAnim.reveal(heading ? [heading] : [], { triggerEl: header || s, start: 'top 78%', fromY: 40,  duration: 0.8, delay: 0.10 });
    GSAPAnim.reveal(sub     ? [sub]     : [], { triggerEl: header || s, start: 'top 78%', fromY: 24,  duration: 0.7, delay: 0.20 });
    GSAPAnim.reveal(cards,                     { triggerEl: s,          start: 'top 80%', fromY: 50,  duration: 0.7, stagger: 0.12, delay: 0.10 });
  }

  function initImageWithText(s) {
    var imgWrap     = s.querySelector('.iwt__image-wrap');
    var content     = s.querySelector('.iwt__content');
    var stars       = s.querySelector('.iwt__stars');
    var quote       = s.querySelector('.iwt__quote');
    var attribution = s.querySelector('.iwt__attribution');
    var socialProof = s.querySelector('.iwt__social-proof');
    var eyebrow     = s.querySelector('.iwt__eyebrow');
    var heading     = s.querySelector('.iwt__heading');
    var description = s.querySelector('.iwt__description');
    var buttons     = s.querySelector('.iwt__buttons');
    /* Image: zoom-in scale animation */
    zoomIn(imgWrap);
    /* Content: staggered fade-up triggered off the content column */
    var delay = 0;
    var step  = 0.12;
    [stars, quote, attribution, socialProof, eyebrow, heading, description, buttons].forEach(function (el) {
      if (!el) return;
      GSAPAnim.reveal([el], { triggerEl: content, start: 'top 100%', fromY: 36, duration: 0.75, delay: delay });
      delay += step;
    });
  }

  function initRelatedProducts(s) {
    var heading    = s.querySelector('.rp-heading');
    var subheading = s.querySelector('.rp-subheading');
    var grid       = s.querySelector('.rp-grid');
    var cards      = s.querySelectorAll('.coll-card');
    GSAPAnim.reveal(heading    ? [heading]    : [], { triggerEl: s, start: 'top 80%', fromY: 36, duration: 0.8 });
    GSAPAnim.reveal(subheading ? [subheading] : [], { triggerEl: s, start: 'top 80%', fromY: 22, duration: 0.7, delay: 0.12 });
    GSAPAnim.reveal(cards,                           { triggerEl: grid || s, start: 'top 82%', fromY: 50, stagger: 0.10, duration: 0.7, delay: 0.20 });
  }

  function initProductBenefitsShowcase(s) {
    var imgWrap  = s.querySelector('.pbs__img-wrap');
    var eyebrow  = s.querySelector('.pbs__eyebrow');
    var heading  = s.querySelector('.pbs__heading');
    var desc     = s.querySelector('.pbs__desc');
    var benefits = s.querySelectorAll('.pbs__benefit');
    var cta      = s.querySelector('.pbs__cta');
    var content  = s.querySelector('.pbs__content');
    zoomIn(imgWrap);
    GSAPAnim.reveal(eyebrow  ? [eyebrow]  : [], { triggerEl: content, start: 'top 78%', fromY: 20,  duration: 0.6 });
    GSAPAnim.reveal(heading  ? [heading]  : [], { triggerEl: content, start: 'top 78%', fromY: 44,  duration: 0.9, delay: 0.10 });
    GSAPAnim.reveal(desc     ? [desc]     : [], { triggerEl: content, start: 'top 78%', fromY: 28,  duration: 0.8, delay: 0.22 });
    GSAPAnim.reveal(benefits,                    { triggerEl: content, start: 'top 78%', fromY: 30,  duration: 0.65, stagger: 0.12, delay: 0.32 });
    GSAPAnim.reveal(cta      ? [cta]      : [], { triggerEl: content, start: 'top 78%', fromY: 18,  duration: 0.6, delay: 0.55 });
  }

  function initWhyItWorks(s) {
    var imgWrap   = s.querySelector('.wiw__img-wrap');
    var eyebrow   = s.querySelector('.wiw__eyebrow');
    var title     = s.querySelector('.wiw__title');
    var desc      = s.querySelector('.wiw__desc');
    var features  = s.querySelectorAll('.wiw__feature');
    var signature = s.querySelector('.wiw__signature');
    var cta       = s.querySelector('.wiw__cta');
    var content   = s.querySelector('.wiw__content');
    /* Image: zoom-in scale animation */
    zoomIn(imgWrap);
    /* Content: staggered fade-up, all triggered off the content column */
    GSAPAnim.reveal(eyebrow   ? [eyebrow]   : [], { triggerEl: content, start: 'top 78%', fromY: 20,  duration: 0.6 });
    GSAPAnim.reveal(title     ? [title]     : [], { triggerEl: content, start: 'top 78%', fromY: 44,  duration: 0.9, delay: 0.10 });
    GSAPAnim.reveal(desc      ? [desc]      : [], { triggerEl: content, start: 'top 78%', fromY: 28,  duration: 0.8, delay: 0.22 });
    GSAPAnim.reveal(features,                      { triggerEl: content, start: 'top 78%', fromY: 30,  duration: 0.65, stagger: 0.12, delay: 0.32 });
    GSAPAnim.reveal(signature ? [signature] : [], { triggerEl: content, start: 'top 78%', fromY: 20,  duration: 0.6, delay: 0.55 });
    GSAPAnim.reveal(cta       ? [cta]       : [], { triggerEl: content, start: 'top 78%', fromY: 18,  duration: 0.6, delay: 0.65 });
  }

  function initCollHero(s) {
    var breadcrumb = s.querySelector('.coll-hero__breadcrumb');
    var title      = s.querySelector('.coll-hero__title');
    var desc       = s.querySelector('.coll-hero__desc');
    var badges     = s.querySelectorAll('.coll-hero__badge');
    var imgWrap    = s.querySelector('.coll-hero__img-wrap');
    GSAPAnim.reveal(breadcrumb ? [breadcrumb] : [], { triggerEl: s, start: 'top 100%', fromY: -18, duration: 0.7 });
    GSAPAnim.reveal(title      ? [title]      : [], { triggerEl: s, start: 'top 100%', fromY: 48,  duration: 0.9, delay: 0.10 });
    GSAPAnim.reveal(desc       ? [desc]       : [], { triggerEl: s, start: 'top 100%', fromY: 36,  duration: 0.8, delay: 0.25 });
    GSAPAnim.reveal(badges,                          { triggerEl: s, start: 'top 100%', fromY: 20,  duration: 0.7, stagger: 0.10, delay: 0.40 });
    GSAPAnim.reveal(imgWrap    ? [imgWrap]    : [], { triggerEl: s, start: 'top 100%', fromX: 70, fromY: 0, duration: 1.0, delay: 0.15 });
  }

  function initCollNavBar(s) {
    var pills = s.querySelectorAll('.coll-nav-pill');
    GSAPAnim.reveal(pills, { triggerEl: s, start: 'top 95%', fromY: 14, stagger: 0.05, duration: 0.5 });
  }

  function initCollLayout(s) {
    var toolbar = s.querySelector('.coll-toolbar');
    var grid    = s.querySelector('.coll-grid');
    var cards   = s.querySelectorAll('.coll-card');
    GSAPAnim.reveal(toolbar ? [toolbar] : [], { start: 'top 88%', fromY: 20, duration: 0.6 });
    GSAPAnim.reveal(cards, { triggerEl: grid || cards[0], start: 'top 82%', fromY: 40, stagger: 0.06, duration: 0.6 });
  }

  function initContentVideo(s) {
    var eyebrow     = s.querySelector('.cv__eyebrow');
    var heading     = s.querySelector('.cv__heading');
    var description = s.querySelector('.cv__description');
    var btn         = s.querySelector('.cv__btn');
    var video       = s.querySelector('.cv__video');
    var content     = s.querySelector('.cv__content');
    var isReverse   = s.classList.contains('cv--reverse');
    GSAPAnim.reveal(eyebrow     ? [eyebrow]     : [], { triggerEl: content, start: 'top 82%', fromY: 20, duration: 0.6 });
    GSAPAnim.reveal(heading     ? [heading]     : [], { triggerEl: content, start: 'top 82%', fromY: 32, duration: 0.8, delay: 0.10 });
    GSAPAnim.reveal(description ? [description] : [], { triggerEl: content, start: 'top 82%', fromY: 24, duration: 0.7, delay: 0.22 });
    GSAPAnim.reveal(btn         ? [btn]         : [], { triggerEl: content, start: 'top 82%', fromY: 18, duration: 0.6, delay: 0.34 });
    GSAPAnim.reveal(video       ? [video]       : [], { triggerEl: s,       start: 'top 80%', fromX: isReverse ? -50 : 50, fromY: 0, duration: 0.9, delay: 0.15 });
  }

  function initHowToVideos(s) {
    var eyebrow  = s.querySelector('.htv__eyebrow');
    var heading  = s.querySelector('.htv__heading');
    var subtext  = s.querySelector('.htv__subtext');
    var items    = s.querySelectorAll('.htv__item');
    GSAPAnim.reveal(eyebrow  ? [eyebrow]  : [], { triggerEl: s, start: 'top 82%', fromY: 20, duration: 0.6 });
    GSAPAnim.reveal(heading  ? [heading]  : [], { triggerEl: s, start: 'top 82%', fromY: 28, duration: 0.7, delay: 0.10 });
    GSAPAnim.reveal(subtext  ? [subtext]  : [], { triggerEl: s, start: 'top 82%', fromY: 20, duration: 0.6, delay: 0.20 });
    GSAPAnim.reveal(items,                       { triggerEl: s, start: 'top 80%', fromY: 40, duration: 0.7, stagger: 0.12, delay: 0.30 });
  }

  function initWholesaleForm(s) {
    var eyebrow     = s.querySelector('.wsf__eyebrow');
    var heading     = s.querySelector('.wsf__heading');
    var description = s.querySelector('.wsf__description');
    var form        = s.querySelector('.wsf__form');
    GSAPAnim.reveal(eyebrow     ? [eyebrow]     : [], { triggerEl: s, start: 'top 82%', fromY: 20, duration: 0.6 });
    GSAPAnim.reveal(heading     ? [heading]     : [], { triggerEl: s, start: 'top 82%', fromY: 32, duration: 0.8, delay: 0.10 });
    GSAPAnim.reveal(description ? [description] : [], { triggerEl: s, start: 'top 82%', fromY: 24, duration: 0.7, delay: 0.22 });
    GSAPAnim.reveal(form        ? [form]        : [], { triggerEl: s, start: 'top 82%', fromX: 40, fromY: 0, duration: 0.9, delay: 0.15 });
  }

  function initImageBanner(s) {
    var eyebrow  = s.querySelector('.ib__eyebrow');
    var heading  = s.querySelector('.ib__heading');
    var subtext  = s.querySelector('.ib__subtext');
    var imgWrap  = s.querySelector('.ib__image-wrap');
    GSAPAnim.reveal(eyebrow ? [eyebrow] : [], { triggerEl: s, start: 'top 82%', fromY: 20, duration: 0.6 });
    GSAPAnim.reveal(heading ? [heading] : [], { triggerEl: s, start: 'top 82%', fromY: 28, duration: 0.7, delay: 0.10 });
    GSAPAnim.reveal(subtext ? [subtext] : [], { triggerEl: s, start: 'top 82%', fromY: 20, duration: 0.6, delay: 0.20 });
    zoomIn(imgWrap);
  }

  /* ─── Section registry ──────────────────────────────────────────── */
  var REGISTRY = [
    { sel: '.main-banner.mb-animate', fn: initMainBanner },
    { sel: '.icon-cards.ic-animate',      fn: initIconCards },
    { sel: '.collection-listing.cl-animate',       fn: initCollectionListing },
    { sel: '.sbs-section',                   fn: initShopBestSellers },
    { sel: '.ctab-section',                  fn: initCollectionTabbing },
    { sel: '.features-strip',               fn: initFeaturesStrip },
    { sel: '.tsl-section',                   fn: initTestimonialsSlider },
    { sel: '.cmp-section',                   fn: initComparison },
    { sel: '.pr-section',                    fn: initPositiveResources },
    { sel: '.nbar-section',                  fn: initNewsletterBar },
    { sel: '.ftr',                           fn: initFooter },
    { sel: '.product-page-row',              fn: initProductTemplate },
    { sel: '.art__hero',                     fn: initArticlePage },
    { sel: '.bb',                            fn: initBlogBanner },
    { sel: '.fb',                            fn: initFeaturedBlog },
    { sel: '.bl',                            fn: initBlogListing },
    { sel: '.contact-hero',                  fn: initContactBanner },
    { sel: '.ct-wrap',                       fn: initContactTemplate },
    { sel: '.cfaq',                          fn: initContactFaq },
    { sel: '.partners',                      fn: initPartners },
    { sel: '.hero-text',                     fn: initRichText },
    { sel: '.ov',                            fn: initOurValues },
    { sel: '.iwt',                           fn: initImageWithText },
    { sel: '.rp-section',                    fn: initRelatedProducts },
    { sel: '.pbs',                           fn: initProductBenefitsShowcase },
    { sel: '.wiw',                           fn: initWhyItWorks },
    { sel: '.coll-hero',                     fn: initCollHero },
    { sel: '.coll-nav-bar',                  fn: initCollNavBar },
    { sel: '.coll-layout',                   fn: initCollLayout },
    { sel: '.cv',                            fn: initContentVideo },
    { sel: '.htv',                           fn: initHowToVideos },
    { sel: '.wsf',                           fn: initWholesaleForm },
    { sel: '.ib',                            fn: initImageBanner },
  ];

  /* Run all matching sections on the current page */
  function initAll() {
    REGISTRY.forEach(function (entry) {
      document.querySelectorAll(entry.sel).forEach(entry.fn);
    });
  }

  /* Re-init a single section element (Theme Editor section:load) */
  function initSectionEl(sectionEl) {
    REGISTRY.forEach(function (entry) {
      var target = sectionEl.matches && sectionEl.matches(entry.sel)
        ? sectionEl
        : sectionEl.querySelector(entry.sel);
      if (target) entry.fn(target);
    });
  }

  /* ─── Boot ──────────────────────────────────────────────────────── */
  document.addEventListener('gsap:ready', initAll);

  /* Theme Editor: re-init when a section is added / reloaded */
  document.addEventListener('shopify:section:load', function (e) {
    if (window.GSAPAnim) initSectionEl(e.target);
  });

})();
